// suppress global warning messages so as not to spam the console during development.
// by intercepting the console.warn function and filtering out messages we want to suppress.
export const suppressWarnings = (shouldSuppress = true) => {
  if (shouldSuppress) {
    // save a reference to the original warn methos
    global.__akinHome_oldWarn = global.__akinHome_oldWarn || console.warn
    global.__akinHome_oldLog = global.__akinHome_oldLog || console.log
    global.console.warn = (str, ...rest) => {
      if (!str) return
      if (typeof str === "string" && str.startsWith("gl.pixelStorei()")) {
        // say nothing on errors we expect
        return
      }
      return global.__akinHome_oldWarn.apply(console, [str, ...rest])
    }
    global.console.log = (str, ...rest) => {
      if (!str) return
      if (typeof str === "string" && str.startsWith("EXGL: gl.pixelStorei()")) {
        // say nothing on errors we expect.
        return
      }
      return global.__akinHome_oldLog.apply(console, [str, ...rest])
    }
  } else {
    console.warn = global.__akinHome_oldWarn
    console.log = global.__akinHome_oldLog
  }
}

suppressWarnings()
